import { SparkleIcon, LayersIcon, GearIcon, SpinnerIcon, ZapIcon } from "../ui/Icons";

type Mode = "single" | "batch";

interface Props {
  mode: Mode;
  onModeChange: (m: Mode) => void;
  onSettingsOpen: () => void;
  onConvert?: () => void;
  converting?: boolean;
  canConvert?: boolean;
}

export function SubHeader({ mode, onModeChange, onSettingsOpen, onConvert, converting, canConvert = true }: Props) {
  return (
    <div className="sub-hdr">
      <div className="sub-left">
        <div className="mode-tabs">
          <button
            className={`mode-tab${mode === "single" ? " active" : ""}`}
            onClick={() => onModeChange("single")}
          >
            <SparkleIcon size={12} /> Rules Editor
          </button>
          <button
            className={`mode-tab${mode === "batch" ? " active" : ""}`}
            onClick={() => onModeChange("batch")}
          >
            <LayersIcon size={12} /> Batch Import
          </button>
        </div>
      </div>

      <div className="sub-right">
        <button
          className="nav-settings-btn"
          onClick={onSettingsOpen}
          title="Conversion settings"
        >
          <GearIcon size={14} />
          Settings
        </button>

        {onConvert && (
          <button
            className="btn-convert"
            onClick={onConvert}
            disabled={converting || !canConvert}
          >
            {converting ? (
              <><SpinnerIcon size={14} /> Converting…</>
            ) : (
              <><ZapIcon size={13} /> Convert</>
            )}
          </button>
        )}
      </div>
    </div>
  );
}
